import styled from 'styled-components'

export const Informations = styled.div`
  height: 155px;
  width: 233px;
  margin: 0px 8px;
`

export const Item = styled.div`
  padding: 0px 8px;
  margin: ${props => (props.margin ? props.margin : '0px')};
  display: ${props => (props.display ? props.display : 'block')};
  justify-content: ${props => (props.justify ? props.justify : 'normal')};

  strong {
    padding: 0px;
    font-style: normal;
    font-size: 20px;
    line-height: 150%;
    color: #2e2d37;
  }
`

export const Text = styled.div`
  font-size: ${props => `${props.size}px`};
  color: ${props => (props.color ? props.color : '#AEAEBA')};
  font-weight: ${props => (props.weight ? props.weight : '500')};
  text-transform: ${props => (props.uppercase ? 'uppercase' : 'none')};
  font-style: normal;
  line-height: 150%;
`

export const ZeroStripes = styled.div`
  background-image: url('/assets/img/zero-stripes.svg');
  position: absolute;
  width: 142px;
  height: 145px;
  top: 10px;
  right: 0;
`
